function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#000",
  fillOpacity: 0.6,
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M9.683 23.741a1.44 1.44 0 0 1-.36-2l6.583-9.463a.48.48 0 0 0 0-.549L9.323 2.262A1.44 1.44 0 0 1 11.688.618l6.582 9.463a3.372 3.372 0 0 1 0 3.837l-6.582 9.463a1.44 1.44 0 0 1-2.005.36z"
}), React.createElement("path", {
  d: "M4.96.892l6.585 9.463c.684.99.684 2.3 0 3.29L4.96 23.107a.961.961 0 0 1-.788.411H.96a.96.96 0 0 1-.788-1.508l6.583-9.463c.23-.33.23-.769 0-1.1L.172 1.988A.96.96 0 0 1 .96.48h3.213a.96.96 0 0 1 .788.412z"
}));

var SvgPortalGo = function SvgPortalGo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPortalGo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/portal-go.d5b656c8.svg";
export { ForwardRef as ReactComponent };